const { SERVICE, ASSIGNMENT, numericStatus } = require('./photographyStatus.cjs');
// Shared facts only. Each role owns its own entry matrix.
const invitationHint = (pending) => pending === true ? "等待另一位创作者接受邀约" : "";
const isBlank = (value) => value === null || value === undefined
    || (typeof value === 'string' && value.trim() === '');
const nullableFactsPresent = (source, fields) => fields.every(key => Object.prototype.hasOwnProperty.call(source, key)
    && (source[key] === null || typeof source[key] === 'string'));
const nullableIntegerFactPresent = (source, key, allowZero) => Object.prototype.hasOwnProperty.call(source, key)
    && (isBlank(source[key]) || (Number.isInteger(Number(source[key]))
        && (allowZero ? Number(source[key]) >= 0 : Number(source[key]) > 0)));
const numberFactPresent = (source, key) => Object.prototype.hasOwnProperty.call(source, key)
    && !isBlank(source[key]) && Number.isFinite(Number(source[key]));
const arrivalFactsConsistent = (source) => {
    const absent = isBlank(source.arrivalId) && isBlank(source.arrivedAt) && isBlank(source.lateMinutes);
    const present = !isBlank(source.arrivalId) && Number.isInteger(Number(source.arrivalId)) && Number(source.arrivalId) > 0
        && !isBlank(source.arrivedAt) && typeof source.arrivedAt === 'string' && !!source.arrivedAt.trim()
        // Lateness is calculated after onsite fulfillment ends, so a valid arrival may still have null lateness.
        && (source.lateMinutes === null || (!isBlank(source.lateMinutes)
            && Number.isInteger(Number(source.lateMinutes)) && Number(source.lateMinutes) >= 0));
    return absent || present;
};
const creatorContractError = (source) => {
    const booleans = ['currentlyAssigned', 'currentServiceAssigned', 'photographyAssigned', 'invitationPrerequisitePending'];
    const valid = booleans.every(key => typeof source[key] === 'boolean')
        && numericStatus(source.assignmentStatus, ASSIGNMENT) !== null
        && ['CONTACTABLE', 'INVITATION_PENDING', 'NOT_CURRENTLY_ASSIGNED', 'SERVICE_ENDED'].includes(source.contactPhase)
        && Number.isInteger(source.directedInvitationCount) && source.directedInvitationCount >= 0 && source.directedInvitationCount <= 2
        && (Array.isArray(source.disputes) || Array.isArray(source.cases)) && Array.isArray(source.acceptanceHistory)
        && nullableFactsPresent(source, ['arrivedAt', 'arrivalInvalidatedAt', 'checkedInAt', 'blockingServiceOrderNo', 'invitationResponseDeadline', 'finishedAt', 'settlementStatus'])
        && numberFactPresent(source, 'serviceOrderAmount')
        && nullableIntegerFactPresent(source, 'arrivalId', false)
        && nullableIntegerFactPresent(source, 'lateMinutes', true)
        && arrivalFactsConsistent(source)
        && (source.serviceStatus !== SERVICE.ACCEPTED || !source.invitationPrerequisitePending || (source.directedInvitationCount > 0 && !!source.invitationResponseDeadline))
        && (source.currentlyAssigned || source.assignmentStatus === ASSIGNMENT.ENDED);
    return valid ? '' : '订单事实不完整或不一致，请重新加载；如仍失败，请联系平台核对接口版本';
};
module.exports = { invitationHint, creatorContractError };
